export enum AddDriverFomNames {
	name = 'names',
	idNumber = 'idNumber',
	driverPhone = 'driverPhone',
}
